import { Component, inject, input, output, computed, ChangeDetectionStrategy, PLATFORM_ID } from '@angular/core';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import * as fromMenu from '@teamfoster/sdk/menu-ngrx';
import { toSignal } from '@angular/core/rxjs-interop';
import { LinkComponent } from '@teamfoster/sdk/button';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { fromEvent } from 'rxjs';
import { DOCUMENT, isPlatformServer, JsonPipe, NgClass } from '@angular/common';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { fade } from 'src/app/animations/simple.animation';
import { IconComponent } from '@teamfoster/sdk/icon';
import { Portal } from 'src/app/portals/models';
import { Location } from '@angular/common';
import { NavTheme } from '../../models/nav-theme.model';
import { Segment } from 'src/app/events/models';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  animations: [fade],
  imports: [RouterModule, LinkComponent, CdkTrapFocus, FromDictionaryPipe, IconComponent, NgClass],
})
export class TopbarComponent {
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);

  menuActive = input<boolean>(false);
  menuTheme = input<NavTheme>('transparent');
  searchActive = input<boolean>(false);
  showProgramCTAButton = input<boolean>(false);
  menu = input<fromMenu.MenuItem[]>([]);
  metaMenu = input<fromMenu.MenuItem[]>([]);
  //activePortal = input<Portal | null>(null);
  //activeSegment = input<Segment | null>(null);

  title = input<string>('Hedon Zwolle');
  theme = input<string>('');
  themeLogo = input.required<{
    logoUrl: string;
    lightModeLogoUrl: string;
  }>();

  toggleOverlay = output<void>();
  closeOverlay = output<void>();
  openOverlay = output<void>();
  openCookiePreferences = output<void>();

  location = inject(Location);

  scrollUpdate = toSignal(fromEvent(this.document, 'scroll').pipe(debounceTime(5)));

  fixed = computed(() => {
    const e = this.scrollUpdate(); // trigger on scrollUpdate
    return (isPlatformServer(this.platformId) ? 0 : window.scrollY) > 104;
  });

  navBarLogoUrl = computed(() => {
    const onLight = this.themeLogo().lightModeLogoUrl;
    const onDark = this.themeLogo().logoUrl;
    const menuTheme = this.menuTheme();
    const menuFixed = this.fixed();
    const menuActive = this.menuActive();

    // Menu overlay is always dark
    if (menuActive) {
      return onDark;
    }

    // The fixed menu has background of body color
    if (this.theme() === 'light' && (menuFixed || menuTheme === 'on-body')) {
      return onLight;
    }

    return onDark;
  });

  //logoUrl = computed(() => {
  //const portalLogo = this.activeSegment()?.logoUrl || this.activePortal()?.logoUrl;
  //const portalLogoLight = this.activeSegment()?.lightModeLogoUrl || this.activePortal()?.lightModeLogoUrl;
  //const fallbackLogo = '/assets/gfx/logos/logo-hedon.svg';
  //const menuTheme = this.menuTheme();
  //const menuFixed = this.fixed();
  //// Menu is always dark
  //if (this.menuActive()) {
  //  return portalLogo;
  //}
  //if (menuFixed && portalLogoLight && this.activePortal()?.bodyCssClass === 'light') {
  //  return portalLogoLight;
  //} else if (menuTheme === 'transparent' && portalLogo) {
  //  return portalLogo;
  //} else if (portalLogoLight) {
  //  return portalLogoLight;
  //}
  //return fallbackLogo;
  //});

  featuredItems = computed(() => {
    return this.menu().filter(item => item.featured);
  });
  menuItems = computed(() => {
    return this.menu().filter(item => !item.featured);
  });

  openSearch() {}

  closeSearch() {
    this.closeOverlay.emit();
    const navigationId = (this.location.getState() as any)?.navigationId || 0;
    if (navigationId > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/']);
    }
  }
}
